module.exports = __webpack_public_path__ + "static/img/far2_active.7aa00df1.png";